import { socialLinks } from 'config/constants/socialLinks';

export const serviceStandards = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Digital Product Design & Development Services',
  description:
    'Boldare is a digital product design and development company offering software development, UX/UI design, AI services, DevOps, consulting, and full digital transformation solutions.',
  provider: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://boldare.com',
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'Zwycięstwa 52',
        addressLocality: 'Gliwice',
        postalCode: '44-100',
        addressCountry: 'PL',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Krucza 50',
        addressLocality: 'Warsaw',
        postalCode: '00-025',
        addressCountry: 'PL',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Wyspa Słodowa 7',
        addressLocality: 'Wroclaw',
        postalCode: '50-266',
        addressCountry: 'PL',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Kurniki 9',
        addressLocality: 'Cracow',
        postalCode: '31-156',
        addressCountry: 'PL',
      },
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      url: 'https://boldare.com/contact',
    },
    sameAs: Object.values(socialLinks),
  },
  areaServed: {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'Worldwide',
    },
  },
  serviceType: [
    'Software Development',
    'UX/UI Design',
    'AI Services',
    'DevOps Consulting',
    'Product Strategy & Innovation',
    'Digital Transformation',
    'Testing & QA',
    'Product Scaling',
    'Dedicated Teams',
    'Team Augmentation',
  ],
  availableChannel: {
    '@type': 'ServiceChannel',
    serviceUrl: 'https://boldare.com/services',
    availableLanguage: ['en'],
  },
  termsOfService: 'https://boldare.com/privacy-policy',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Digital Product Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Full Cycle Product Development',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'AI Services & Generative AI',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'App Accessibility Audit & Implementation',
        },
      },
    ],
  },
};
